import {
  AddInter,
  AllianceFixInter,
  AllianceInsertInter,
  MeetupType,
  ProjectAction,
  ProjectType,
} from "./interface";

export function AllianceInsertreducer(
  state: AllianceInsertInter | AllianceFixInter,
  { payload, type }: ProjectAction
) {
  switch (type) {
    case "dispatch/img":
      return { ...state, thumbnail: payload };
    case "dispatch/prtn_nm":
      return { ...state, prtn_nm: payload };
    case "dispatch/prtn_desc":
      return { ...state, prtn_desc: payload };
    case "dispatch/prtn_info":
      return { ...state, prtn_info: payload };
    case "dispatch/prtn_use":
      return { ...state, prtn_use: payload };
    case "dispatch/link":
      return { ...state, link: payload };
    case "dispatch/all":
      return payload;
    default:
      throw new Error(`Unhandled action type: ${type}`);
  }
}

export function ProjectReducer(
  state: ProjectType,
  { payload, type, index }: ProjectAction
) {
  switch (type) {
    case "dispatch/all":
      return payload;
    case "finish_time":
      return { ...state, finish_time: payload };
    case "leader/img":
      return {
        ...state,
        leader: {
          ...state.leader,
          img: payload,
        },
      };
    case "leader/title":
      return {
        ...state,
        leader: {
          ...state.leader,
          title: payload,
        },
      };
    case "leader/link":
      return {
        ...state,
        leader: {
          ...state.leader,
          link: payload,
        },
      };
    case "leader/intro":
      return {
        ...state,
        leader: {
          ...state.leader,
          intro: payload,
        },
      };
    case "leader/sub":
      return {
        ...state,
        leader: {
          ...state.leader,
          sub: payload,
        },
      };
    case "leader/info":
      return {
        ...state,
        leader: {
          ...state.leader,
          name: payload.name,
          id: payload.id,
        },
      };
    case "mainimg":
      return { ...state, mainimg: payload };
    case "category":
      return { ...state, category: payload };
    case "title":
      return { ...state, title: payload };
    case "price":
      return { ...state, price: payload };
    case "template":
      return { ...state, template: payload };
    case "start":
      return {
        ...state,
        period: {
          ...state.period,
          start: payload,
        },
      };
    case "finish":
      return {
        ...state,
        period: {
          ...state.period,
          finish: payload,
        },
      };
    case "rough":
      return {
        ...state,
        field: {
          ...state.field,
          rough: payload,
        },
      };
    case "detail/remove":
      let remove_arr = state.field.detail;
      if (index !== undefined) {
        remove_arr[index].IUD = "D";
      }
      return {
        ...state,
        field: {
          ...state.field,
          detail: remove_arr,
        },
      };
    case "detail/add":
      let add_arr = state.field.detail;
      add_arr.push({
        IUD: "I",
        rcrt_nm: "",
        rcrt_ctts: "",
        rcrt_type_cd: "design",
        attd_amt: 0,
        rcrt_usr_cnt: 0,
      });
      return {
        ...state,
        field: {
          ...state.field,
          detail: add_arr,
        },
      };
    case "detail/category":
      let category_arr = state.field.detail;
      if (index !== undefined) {
        category_arr[index].rcrt_type_cd = payload;
      }
      return {
        ...state,
        field: {
          ...state.field,
          detail: category_arr,
        },
      };
    case "detail/title":
      let title_arr = state.field.detail;
      if (index !== undefined) {
        title_arr[index].rcrt_nm = payload;
      }
      return {
        ...state,
        field: {
          ...state.field,
          detail: title_arr,
        },
      };
    case "detail/sub":
      let sub_arr = state.field.detail;
      if (index !== undefined) {
        sub_arr[index].rcrt_ctts = payload;
      }
      return {
        ...state,
        field: {
          ...state.field,
          detail: sub_arr,
        },
      };
    case "detail/num":
      let num_arr = state.field.detail;
      if (index !== undefined) {
        num_arr[index].rcrt_usr_cnt = payload;
      }
      return {
        ...state,
        field: {
          ...state.field,
          detail: num_arr,
        },
      };
    case "rewards/remove":
      let re_remove_arr = state.rewards;
      if (index !== undefined) {
        re_remove_arr.splice(index, 1);
      }
      return {
        ...state,
        rewards: re_remove_arr,
      };
    case "rewards/add":
      let re_add_arr = state.rewards;
      re_add_arr.push({ bnfit_impt_fg: false, bnfit_nm: "" });
      return {
        ...state,
        rewards: re_add_arr,
      };
    case "rewards/title":
      let re_title_arr = state.rewards;
      if (index !== undefined) {
        re_title_arr[index].bnfit_nm = payload;
      }
      return {
        ...state,
        field: {
          ...state.field,
          rewards: re_title_arr,
        },
      };
    case "rewards/fg":
      let re_fg_arr = state.rewards;
      if (index !== undefined) {
        re_fg_arr[index].bnfit_impt_fg = !re_fg_arr[index].bnfit_impt_fg;
      }
      return {
        ...state,
        rewards: re_fg_arr,
      };
    case "pnlt/add":
      let pnlt_remove_arr = state.pnlt_lst;
      pnlt_remove_arr.push({ bnfit_nm: payload });
      return {
        ...state,
        pnlt_lst: pnlt_remove_arr,
      };
    case "pnlt/remove":
      let pnly_add_arr = state.pnlt_lst;
      if (index !== undefined) {
        pnly_add_arr.splice(index, 1);
      }
      return {
        ...state,
        pnlt_lst: pnly_add_arr,
      };
    default:
      throw new Error(`Unhandled action type: ${type}`);
  }
}

export function MeetupReducer(
  state: MeetupType,
  { payload, type, index }: ProjectAction
) {
  switch (type) {
    case "reset":
      return state;
    case "dispatch/all":
      return payload;
    case "leader/title":
      return {
        ...state,
        leader: {
          ...state.leader,
          title: payload,
        },
      };
    case "finish_time":
      return { ...state, finish_time: payload };
    case "leader/link":
      return {
        ...state,
        leader: {
          ...state.leader,
          link: payload,
        },
      };
    case "leader/intro":
      return {
        ...state,
        leader: {
          ...state.leader,
          intro: payload,
        },
      };
    case "leader/img":
      return {
        ...state,
        leader: {
          ...state.leader,
          img: payload,
        },
      };
    case "leader/sub":
      return {
        ...state,
        leader: {
          ...state.leader,
          sub: payload,
        },
      };
    case "leader/info":
      return {
        ...state,
        leader: {
          ...state.leader,
          name: payload.name,
          id: payload.id,
        },
      };
    case "max":
      return { ...state, max: payload };
    case "mainimg":
      return { ...state, mainimg: payload };
    case "link":
      return { ...state, link: payload };
    case "category":
      return { ...state, category: payload };
    case "price":
      return { ...state, price: payload };
    case "template":
      return { ...state, template: payload };
    case "title":
      return { ...state, title: payload };
    case "start":
      return {
        ...state,
        period: {
          ...state.period,
          start: payload,
        },
      };
    case "finish":
      return {
        ...state,
        period: {
          ...state.period,
          finish: payload,
        },
      };
    case "address":
      return {
        ...state,
        address: {
          ...state.address,
          basic: payload,
        },
      };
    case "ad-detail":
      return {
        ...state,
        address: {
          ...state.address,
          detail: payload,
        },
      };
    case "pnlt/add":
      let pnlt_remove_arr = state.pnlt_lst;
      pnlt_remove_arr.push({ bnfit_nm: payload });
      return {
        ...state,
        pnlt_lst: pnlt_remove_arr,
      };
    case "pnlt/remove":
      let pnly_add_arr = state.pnlt_lst;
      if (index !== undefined) {
        pnly_add_arr.splice(index, 1);
      }
      return {
        ...state,
        pnlt_lst: pnly_add_arr,
      };
    default:
      throw new Error(`Unhandled action type: ${type}`);
  }
}

export function AddInsertreducer(
  state: AddInter,
  { payload, type }: ProjectAction
) {
  switch (type) {
    case "add/img":
      return { ...state, ad_thumbnail: payload };
    case "add/color":
      return { ...state, bg_color: payload };
    case "add/title":
      return { ...state, ctts_tit: payload };
    case "add/link":
      return { ...state, ctts_link: payload };
    case "add/content":
      return { ...state, ctts_ctts: payload };
    case "add/btn":
      return { ...state, btn_label: payload };
    case "add/type":
      return { ...state, ctts_ctg_cd: payload };
    case "add/all":
      return payload;
    default:
      throw new Error(`Unhandled action type: ${type}`);
  }
}

export function Couponreducer(
  state: {
    title: string;
    period: string;
    percent: number;
    type: "prjt" | "mtup";
    list: [];
  },
  { payload, type }: ProjectAction
) {
  switch (type) {
    case "coupon/title":
      return { ...state, title: payload };
    case "coupon/finish":
      return { ...state, period: payload };
    case "coupon/percent":
      return { ...state, percent: payload };
    case "coupon/list":
      return { ...state, list: payload };
    case "coupon/type":
      return { ...state, type: payload };
    case "coupon/all":
      return payload;
    default:
      throw new Error(`Unhandled action type: ${type}`);
  }
}
